import React, { useEffect, useState } from 'react'
import useApi from '../../api';
import { toast } from 'react-toastify';
import { NxtbnDrawer } from '../../components';
import ReceiveInventory from './receiveInventory';
import PurchaseEdit from './PurchaseEdit';


interface PurchaseViewProps{
    instance: any;
    isOpen: boolean;
    onClose: ()=>void;
    refresh: ()=>void;
}

function PurchaseView({instance, isOpen, onClose, refresh}:PurchaseViewProps) {
    const [purchase, setPurchase] = useState<any>();
    const [openEdit, setOpenEdit] = useState(false);
    const [openReceiveInventory, setOpenReceiveInventory] = useState(false);

    const api = useApi()

    useEffect(()=>{
        if (instance){
            api.getDetailPurchase(instance.id).then((response:any)=>{
                setPurchase(response)
                
            }).catch((error)=>toast.error('Error get details purchase'))
        }
    }, [instance])

    useEffect(()=>{
        if(purchase){
            instance.items = purchase?.items
        }
    }, [purchase])

    const markAsOrdered = () =>  {
        api.markOrderAsOrdered(instance?.id).then((response) => {

        }, (error) => {
            toast.error('Error marking order as ordered.')
        })
    }

    const deletePurchase = () => {
        api.deletePurchase(instance?.id).then((response) => {
            toast.success('Purchase deleted successfully.')
            refresh()
            onClose()
        }, (error) => {
            toast.error('Error deleting purchase.')
        })
    }

    const cancelPurchase = () =>  {
        api.cancelPurchaseOrder(instance?.id).then((response) => {
            toast.success('Purchase cancelled successfully.')
            refresh()
            onClose()
        }, (error) => {
            toast.error('Error cancelling purchase.')
        })
    }

    const markAsReceived = () => {
        api.markPurchaseOrderAsReceived(instance?.id).then((response) => {
            toast.success('Purchase marked as received successfully.')
            refresh()
            onClose()
        }, (error) => {
            toast.error('Error marking purchase as received.')
        })
    }
    
  return (
    <NxtbnDrawer isOpen={isOpen} onClose={onClose} title='Purchase Detail'>
        {purchase?.status === 'DRAFT' && (
            <div className="flex gap-2 mb-4">
                <button onClick={() => setOpenEdit(true)} className="bg-blue-500 text-white py-2 px-4 rounded">
                    Edit
                </button>
                <button onClick={markAsOrdered} className="bg-gray-500 text-white py-2 px-4 rounded">
                    Mark as Ordered
                </button>
                <button onClick={cancelPurchase} className="bg-gray-500 text-white py-2 px-4 rounded">
                    Cancel
                </button>
                <button onClick={deletePurchase} className="bg-red-500 text-white py-2 px-4 rounded">
                    Delete
                </button>
            </div>
        )}
        {purchase?.status === 'PENDING' && (
           <>
             <div className="mb-4">
                <button onClick={() => setOpenReceiveInventory(true)}  className="bg-blue-500 text-white py-2 px-4 rounded">
                    Receive Inventory
                </button>
            </div>
            <div>
                <button onClick={markAsReceived} className="bg-gray-500 text-white py-2 px-4 rounded">
                    Mark as Received
                </button>
            </div>
           </>
        )}

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Purchase Info</h3>
            <div>
                <div><strong>Purchase ID: </strong>{purchase?.id}</div>
                <div><strong>Total cost: </strong>{purchase?.total_cost}</div>
                <div><strong>Purchase status: </strong>{purchase?.status}</div>
                <div><strong>Expected delivery date: </strong>{purchase?.expected_delivery_date}</div>
            </div>
        </div>

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Supplier Info</h3>
            <div>
                <div><strong>ID: </strong>{purchase?.supplier.id}</div>
                <div><strong>Name: </strong>{purchase?.supplier.name}</div>
                <div><strong>Description: </strong>{purchase?.supplier.description}</div>
            </div>
        </div>

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Destination Info</h3>
            <div>
                <div><strong>ID: </strong>{purchase?.destination.id}</div>
                <div><strong>Name: </strong>{purchase?.destination.name}</div>
                <div><strong>Location: </strong>{purchase?.destination.location}</div>
            </div>
        </div>

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Created by</h3>
            <div>
                <div><strong>First Name: </strong>{purchase?.created_by?.first_name}</div>
                <div><strong>Last Name: </strong>{purchase?.created_by?.last_name}</div>
                <div><strong>Username: </strong>{purchase?.created_by?.username}</div>
                <div><strong>Email: </strong>{purchase?.created_by?.email}</div>
            </div>
        </div>

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Purchase Order Items</h3>
            {purchase?.items.map((item: any, index: number) => (
                <div key={index} className='border p-2 mt-2 rounded-md'>
                    <div><strong>Variant Name: </strong>{item?.variant?.name}</div>
                    <div><strong>Variant ID: </strong>{item?.variant?.id}</div>
                    <div><strong>Variant SKU: </strong>{item?.variant?.sku}</div>
                    <div><strong>Variant Price: </strong>{item?.variant?.price}</div>
                    <div><strong>Ordered quantity: </strong>{item?.ordered_quantity}</div>
                    <div><strong>Unit cost: </strong>${item?.unit_cost}</div>
                </div>
            ))}
        </div>

        {openEdit && <PurchaseEdit pid={instance.id} isOpen={openEdit} onClose={()=>setOpenEdit(!openEdit)} refresh={refresh}/>}  
        <ReceiveInventory data={purchase} isOpen={openReceiveInventory} onClose={()=> setOpenReceiveInventory(false)} purchaseOrderId={instance?.id} refresh={refresh} />
    </NxtbnDrawer>
  )
}

export default PurchaseView